export default __webpack_public_path__ + "static/media/doc.8a1f2e63.svg";